var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconOutlineCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.889 3.5a.97.97 0 0 1 .972.963v.962h.972c1.608 0 2.917 1.296 2.917 2.888v11.55c0 1.591-1.309 2.887-2.917 2.887H8.167c-1.608 0-2.917-1.296-2.917-2.887V8.313c0-1.592 1.309-2.888 2.917-2.888h.972v-.962a.97.97 0 0 1 .972-.963.97.97 0 0 1 .972.963v.962h5.834v-.962a.97.97 0 0 1 .972-.963zm2.917 10.588H7.194v5.775c0 .53.437.962.973.962h11.666a.969.969 0 0 0 .973-.962v-5.775zM10.11 16.012a.97.97 0 0 1 .972.962.97.97 0 0 1-.972.962.97.97 0 0 1-.972-.962.97.97 0 0 1 .972-.963zm7.778 0a.97.97 0 0 1 .972.962.97.97 0 0 1-.972.962H14a.97.97 0 0 1-.972-.962.97.97 0 0 1 .972-.963z",
    fill: "#F60",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconOutlineCalendar);
export default __webpack_public_path__ + "static/media/atoms-icon-outline-calendar.002d064bb5a844e541fd89aacc4de7f0.svg";
export { ForwardRef as ReactComponent };